var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"education-content tabs-full",attrs:{"type":"card"},model:{value:(_vm.decorationTab),callback:function ($$v) {_vm.decorationTab=$$v},expression:"decorationTab"}},[_c('el-tab-pane',{attrs:{"label":"新客服管理","name":"newkefuManage"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }